import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import './i18n';

// This simplified approach lets the app handle language routing internally
// without relying on Netlify redirects that might cause loops

console.log('[Language Routing] Starting initialization...');
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);